import { render, staticRenderFns } from "./teilnehmer-dokumente.vue?vue&type=template&id=19f22a18&scoped=true"
import script from "./teilnehmer-dokumente.vue?vue&type=script&lang=js"
export * from "./teilnehmer-dokumente.vue?vue&type=script&lang=js"
import style0 from "./teilnehmer-dokumente.vue?vue&type=style&index=0&id=19f22a18&prod&lang=scss&scoped=true"
import style1 from "./teilnehmer-dokumente.vue?vue&type=style&index=1&id=19f22a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f22a18",
  null
  
)

export default component.exports